import React from "react";
import PropTypes from "prop-types";
import styles from "./EditIcon.module.scss";

// Two render modes:
//
// 1. Standalone interactive (onClick provided) — render a real <button>.
// 2. Decorative (no onClick) — the icon is embedded inside an existing
//    interactive parent (e.g. an MUI <Button>). It MUST NOT render a
//    <button> itself, because <button> inside <button> is invalid HTML
//    and breaks keyboard/click handling. Instead we render a
//    non-interactive <span role="img"> with an aria-label so the parent
//    button still has an accessible name.
//
// Also: only emit the `id` attribute when an `id` prop is actually
// provided. The previous implementation always rendered
// `id={"edit" + this.props.id}`, which produced colliding
// `id="editundefined"` values on every consumer that didn't pass one.
const EditIcon = ({ id, onClick, ariaLabel = "Edit" }) => {
  const idAttr = id !== undefined && id !== null ? `edit${id}` : undefined;

  if (onClick) {
    return (
      <button
        type="button"
        data-testid="editIcon"
        id={idAttr}
        className={styles.Edit}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        <span className={styles.RectangleStart}>&nbsp;</span>
        <span className={styles.RectangleEnd}>&nbsp;</span>
      </button>
    );
  }

  return (
    <span
      role="img"
      aria-label={ariaLabel}
      data-testid="editIcon"
      id={idAttr}
      className={styles.Edit}
    >
      <span className={styles.RectangleStart}>&nbsp;</span>
      <span className={styles.RectangleEnd}>&nbsp;</span>
    </span>
  );
};

EditIcon.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
};

export default EditIcon;
